const cssStyles = () => `
.EuCookieBar__learnMore:hover, .EuCookieBar__learnMore:focus {
  text-decoration: underline;
}
.EuCookieBar__cookieButton {
  background-color: transparent;
  -webkit-text-size-adjust: 120%;
}
.EuCookieBar__cookieButton:hover, .EuCookieBar__cookieButton:focus {
  background-color: #999;
  opacity: 1;
}
`;

export default cssStyles;
